/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponsePagedResultContact } from '../../models/api-response-paged-result-contact';
import { PagedRequestContactSearchReq } from '../../models/paged-request-contact-search-req';

export interface SearchSegmentContacts$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  ref: string;
      body: PagedRequestContactSearchReq
}

export function searchSegmentContacts(http: HttpClient, rootUrl: string, params: SearchSegmentContacts$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponsePagedResultContact>> {
  const rb = new RequestBuilder(rootUrl, searchSegmentContacts.PATH, 'post');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('ref', params.ref, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponsePagedResultContact>;
    })
  );
}

searchSegmentContacts.PATH = '/v1/api/ui/contactSegment/{ref}/contacts/search';
